import dayjs from "dayjs";
import { autorun, makeAutoObservable } from "mobx";
import { Translates } from "./translates";
require("dayjs/locale/ru");
require("dayjs/locale/en");


// Доступные языки
export const AvailableLanguages: Map<string, string> = new Map<string, string>([
    ["en", "English"],
    ["ru", "Русский"],
])

// Ключ данных в localStorage
const i18nKey: string = "i18n";


class I18nStore {
    private currentLanguageCode: string = window.localStorage.getItem(i18nKey) || "en";

    constructor() {
        makeAutoObservable(this);
        dayjs.locale(this.currentLanguageCode);
        autorun(() => {
            this.initStore();
        });
    }

    initStore(): void {
        console.log("i18n store initialized");
    }

    update(languageCode: string) {
        this.currentLanguageCode = languageCode;
        window.localStorage.setItem(i18nKey, this.currentLanguageCode);
        dayjs.locale(languageCode);
    }
    get getCurrentLanguageCode(): string {
        return this.currentLanguageCode || "en";
    }

    get getTranslations(): any {
        // @ts-ignore
        return Translates[this.currentLanguageCode];
    }
}

const i18nStore = new I18nStore();
export default i18nStore;
